import { createSlice } from "@reduxjs/toolkit";

const initialAgentsListingsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  meta: {},
  entities: null,
  listingForEdit: undefined,
  lastError: null,
  queryParams: {},
  filters: {},
};
export const AdminCallTypes = {
  list: "list",
  action: "action",
};

export const adminAgentFollowupsSlice = createSlice({
  name: "adminAgentFollowupsSlice",
  initialState: { ...initialAgentsListingsState },
  extraReducers: (builder) => {
    builder.addCase("[Auth] Logout Action", (state, action) => {
      return { ...initialAgentsListingsState };
    });
  },
  reducers: {
    reset: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.totalCount = 0;
      state.entities = null;
      state.listingForEdit = undefined;
      state.lastError = null;
      state.queryParams = {};
      state.filters = {};
    },
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === AdminCallTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === AdminCallTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    listingFetched: (state, action) => {
      state.actionsLoading = false;
      state.listingForEdit = action.payload.listingForEdit;
      state.error = null;
    },
    agentlistingsFetched: (state, action) => {
      var { meta, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.meta = meta;
      state.entities = entities;
      if (action.payload["queryParams"]) {
        state.queryParams = action.payload["queryParams"];
      }
    },
    setFilters: (state, action) => {
      state.listLoading = false;
      if (action.payload["filters"]) {
        state.filters = { ...action.payload["filters"] };
      }
    },
  },
});
